import { Button } from '@radix-ui/themes';
import useEmblaCarousel from 'embla-carousel-react';
import { Link } from 'react-router-dom';
import { setInteractingWithCarousel } from 'store/misc/uiSlice';
import { useAppDispatch } from 'store/store';
import type { LastMatchesType } from 'types/match';
import type { PlayerDetailType } from 'types/player';
import { PrevButton, NextButton, usePrevNextButtons } from './CarouselButtons';
import MatchCardObject from './MatchCardObject';

export const MatchCarousel: React.FC<{ player: PlayerDetailType; loading: boolean; matches: LastMatchesType[] }> = ({
  player,
  loading,
  matches,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({});
  const dispatch = useAppDispatch();

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  return (
    <section className='relative'>
      <div
        className='w-full overflow-hidden'
        ref={emblaRef}
        onTouchStart={() => dispatch(setInteractingWithCarousel(true))}
        onTouchEnd={() => dispatch(setInteractingWithCarousel(false))}
      >
        <div className='flex touch-pan-y touch-pinch-zoom gap-3'>
          {matches.map((match) => (
            <div key={match.id} className='flex-[0_0_60%]'>
              <div className='flex h-full w-full items-center self-stretch'>
                <MatchCardObject player={player} loading={loading} {...match} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='mt-4 flex flex-row justify-between'>
        <div>
          <div className='flex gap-2'>
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        </div>
        <Link to={`/giocatore/${player.id}/partite`}>
          <Button className='cursor-pointer'>Vedi tutte</Button>
        </Link>
      </div>
    </section>
  );
};

export default MatchCarousel;
